import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problema from './components/Problema';
import ComoFunciona from './components/ComoFunciona';
import CasosDeUso from './components/CasosDeUso';
import Implementacion from './components/Implementacion';
import ROI from './components/ROI';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';
import Footer from './components/Footer';
import TerminosCondiciones from './components/TerminosCondiciones';

export default function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);

  if (path === '/terminos') {
    return <TerminosCondiciones />;
  }

  return (
    <>
      <Navbar />
      <Hero />
      <Problema />
      <ComoFunciona />
      <CasosDeUso />
      <Implementacion />
      <ROI />
      <FAQ />
      <CTAFinal />
      <Footer />
    </>
  );
}
